module.exports = "<app-navigation></app-navigation>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 388
// module chunks = 1